import React, { useSyncExternalStore } from 'react';
import { Button } from 'reactstrap';
import { FaCloudDownloadAlt } from 'react-icons/fa';
import {
  getVersionGateState,
  subscribeToVersionGate,
  openUpgradeUrl,
} from '../../services/versionGate';

/**
 * Non-dismissable full-screen overlay shown when the installed app version
 * is below the server-driven minimum (DP-2204). No close control by design;
 * Android back is no-op'd in backButton.ts while the gate is up.
 */
const SERVER_SNAPSHOT = { gated: false, upgradeUrl: '' };

const ForceUpgradeGate = () => {
  const { gated } = useSyncExternalStore(
    subscribeToVersionGate,
    getVersionGateState,
    () => SERVER_SNAPSHOT
  );

  if (!gated) return null;

  return (
    <div className="force-upgrade-gate d-flex flex-column align-items-center justify-content-center text-center p-4">
      <FaCloudDownloadAlt size={64} className="text-primary mb-4" />
      <h2 className="mb-3">Update Required</h2>
      <p className="text-muted mb-4">
        This version of the DentalPost app is no longer supported. Please update
        to the latest version to continue.
      </p>
      <Button color="primary" size="lg" onClick={openUpgradeUrl}>
        Update Now
      </Button>
    </div>
  );
};

export default ForceUpgradeGate;
